import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {userLogout as userLogoutAction} from 'admin-on-rest';
import {clearUser} from '../../authClient';
import {getKeycloakLogoutUrl} from '../shared/tokenFunctions';
import MenuItem from 'material-ui/MenuItem';
import ExitIcon from 'material-ui/svg-icons/action/power-settings-new';

const LogoutButton = (props) => {

    const handleLogout = (e) => {
        const authMethod = localStorage.getItem('auth_method');
        if (authMethod === 'kc') {
            clearUser();
            window.location.href = getKeycloakLogoutUrl();
        } else {
            const {userLogout} = props;
            userLogout();
        }
    };

    return (
        <MenuItem
            leftIcon={<ExitIcon/>}
            primaryText="Logout"
            onClick={handleLogout}
        />
    )
};

function mapStateToProps(state, ownProps) {
    return {
    };
}

const enhance = compose(
    connect(
        mapStateToProps,
        {userLogout: userLogoutAction}
    )
);

export default enhance(LogoutButton);



// WEBPACK FOOTER //
// ./src/Fuse/buttons/LogoutButton.js